import module from 'module';
import {NgTableParams} from 'ng-table/ng-table.js';
import _ from 'lodash';

import templateUrl from './red-flag-acknowledgement.template.html';
import './red-flag-acknowledgement.style.less';

class RedFlagAcknowledgementView {
  constructor($location, nav, http, command, redFlagAlertNotificationService, postingDateService, branchService, authentication) {
    this.$location = $location;
    this.nav = nav;
    this.http = http;
    this.command = command;
    this.redFlagAlertNotificationService = redFlagAlertNotificationService;
    this.postingDateService = postingDateService;
    this.branchService = branchService;
    this.authentication = authentication;
  }

  async $onInit() {
    const hasCompliancePermission = this.authentication.permissions['MNG_COMPLIANCE_READ'];

    if (!hasCompliancePermission) {
      this.$location.path("");
    }

    const userBranchPostingDate = await this.postingDateService.getCurrentUserBranchPostingDate();
    const formattedDate = moment(userBranchPostingDate).format('YYYY-MM-DD');
    const branches = await this.branchService.toPromise();

    this.branches = branches.filter(b => !b.closed).map(b => {
      return {
        id: b.id,
        code: b.name
      }
    });
    this.branchIds = [_.find(this.branches, {id: this.authentication.context.branchId}).id];
    this.filter = {
      date: {
        from: formattedDate,
        to: formattedDate
      }
    };
  }

  refreshTable() {
    this.initializeTableConfig();
  }

  async initializeTableConfig() {
    this.tableConfig = await new NgTableParams({
      count: 20
    }, {
      counts: [],
      paginationMinBlocks: 3,
      paginationMaxBlocks: 8,
      getData: params => this.fetchAcknowledgements(params)
    });
  }

  async fetchAcknowledgements(params) {
    const queryParams = {
      pageNo: params.page() - 1,
      pageSize: params.count(),
      branchIds: this.branchIds,  
      dateFrom: this.filter.date.from,
      dateTo: this.filter.date.to
    };

    const response = await this.http.get(`/management/red-flag-alert?${$.param(queryParams, true)}`).toPromise();
    this.tableConfig.total(response.totalCount);
    this.redFlagAlerts = response.result;

    return this.redFlagAlerts;
  }

  isPending(alert) {
    return alert.status === 'PENDING';
  }

  async acknowledgeRedFlagAlert(alert) {
    // Check any inputs on the PENDING alerts and temporarily save their responses.
    let inputs = [];
    let list = this.redFlagAlerts;
    for (const l of list) {
      if (l.status === 'PENDING' && l.remarks && l.remarks.length) {
        inputs.push({id: l.id, remarks: l.remarks});
      }
    }

    await this.command.execute('AcknowledgeRedFlagAlert', {
      id: alert.id,
      remarks: alert.remarks
    }).toPromise();

    await this.tableConfig.reload();
    await this.redFlagAlertNotificationService.fetchNotifications();

    // Put the unsaved responses back.
    let updatedList = this.redFlagAlerts;
    for (const i of inputs) {
      let element = _.find(updatedList, {id: i.id});

      if (element) {
        element.remarks = i.remarks;
      }
    }
  }

  goBack() {
    this.nav.back();
  }
}

module.component('redFlagAcknowledgementView', {
  templateUrl: templateUrl,
  controller: RedFlagAcknowledgementView
});